export default __webpack_public_path__ + "static/media/work10.efb09b93.jpeg";